// 一些无法分类或者功能很少没必要使用单独文件的函数，可以暂时放到这个里，积累到一定梳理，再抽取到独立文件中
import { getConf } from '../../build/conf';
import { createAndGetPreviewPdf } from '@/data-model';
import { API_IMG_DOWNLOAD } from '@/common/constants';
import { Message, Loading } from 'element-ui';
/**
 * 获取系统的全局配置信息
 */
export const getGlobalConf = () => {
    return getConf();
};

export const getUUID = (len, radix) => {
    let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    let uuid = [];
    let i;
    radix = radix || chars.length;

    if (len) {
        // Compact form
        for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
    } else {
        // rfc4122, version 4 form
        let r;

        // rfc4122 requires these characters
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        uuid[14] = '4';

        // Fill in random data.  At i==19 set the high bits of clock sequence as
        // per rfc4122, sec. 4.1.5
        for (i = 0; i < 36; i++) {
            if (!uuid[i]) {
                r = 0 | Math.random() * 16;
                uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
            }
        }
    }

    return uuid.join('');
};

export async function getPreviewFileUrl (file) {
    let previewUrl = null;
    let directFileExtend = '.gif,.png,.jpg,.jpeg,.ico,.bmp,.pdf,.PDF,.PNG,.JPG,.JPEG';// 直接打开
    let officeFileExtend = '.doc,.docx,.xls,.xlsx,.ppt,.pptx,.DOC,.DOCX,.XLS,.XLSX,.PPT,.PPTX';// 转换pdf打开
    let otherFileExtend = '.txt,.TXT';// 转换pf打开
    let filename = decodeURIComponent(file.fileName);
    let fileSuffix = filename.substring(filename.lastIndexOf('.')).toLowerCase();
    if (directFileExtend.indexOf(fileSuffix) > -1) {
        previewUrl = `${API_IMG_DOWNLOAD}${file.filePath}`;
    } else if (officeFileExtend.indexOf(fileSuffix) > -1 || otherFileExtend.indexOf(fileSuffix) > -1) {
        let param = {
            filePath: file.filePath,
            fileId: file.id
        };
        let loading = Loading.service({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });

        try {
            let res = await createAndGetPreviewPdf(param);
            previewUrl = getEnvPrefix() + res.pdfPath;
            loading.close();
        } catch (error) {
            loading.close();
            console.error('文件预览失败' + error);
        }
    } else {
        Message({message: '该文件不支持预览！暂支持格式为:[.gif,.png,.jpg,.ico,.bmp,.pdf,.PDF,.txt,.doc,.docx,.xls,.xlsx,.ppt,.pptx]的文件', type: 'warning'});
        previewUrl = null;
    }
    return previewUrl;
};

function getEnvPrefix () {
    let prefix = '';
    let env = process.env.NODE_ENV;
    if (env === 'production') {
        prefix = '/bcbpm/';
    }
    return prefix;
};

/**
 * 判断json对象及子表单subform所有行中所有属性值是否为空
 * @param obj 要判断的json对象
 * @param attr 对象key的集合
 * @returns true:全部为空，false：至少有一个属性不为空
 */
export const objectKeyIsEmpty = (obj, attr) => {
    let empty = null;
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            if (attr && attr[key] === 'subform' && obj[key].length > 0) {
                for (let i in obj[key]) {
                    let item = obj[key][i];
                    for (let key in item) {
                        if (item.hasOwnProperty(key)) {
                            if (typeof (item[key]) === 'undefined' || item[key] === null ||
                            (item[key] instanceof Array && item[key].length === 0) ||
                            (typeof (item[key]) !== 'object' && typeof (item[key]) !== 'boolean' && (typeof (item[key]) === 'number' ? item[key].toString() : item[key].trim()) === '')) {
                                empty = true;
                            } else {
                                empty = false;
                                return empty;
                            }
                        }
                    }
                    if (empty === false) {
                        return empty;
                    }
                }
            } else {
                if (typeof (obj[key]) === 'undefined' || obj[key] === null ||
                    (obj[key] instanceof Array && obj[key].length === 0) ||
                    (typeof (obj[key]) !== 'object' && typeof (obj[key]) !== 'boolean' && (typeof (obj[key]) === 'number' ? obj[key].toString() : obj[key].trim()) === '')) {
                    empty = true;
                } else {
                    empty = false;
                    return empty;
                }
            }
        }
    }
    return empty;
};



// WEBPACK FOOTER //
// ./src/utils/grocer.js